/**
 * Оформление редкостей.
 *
 * Цвет здесь — не украшение, а единственный быстрый признак ценности предмета:
 * игрок не читает сумму, он смотрит на свечение. Поэтому шкала идёт от серого
 * к золотому монотонно, без произвольной радуги, и один и тот же цвет
 * используется и в ленте, и в сетке, и в окне результата.
 */

import type { CaseRarity } from "@koshkodrop/shared";

export const RARITY_ORDER: readonly CaseRarity[] = [
  "common",
  "uncommon",
  "rare",
  "epic",
  "legendary",
];

export const RARITY_LABEL: Record<CaseRarity, string> = {
  common: "обычный",
  uncommon: "необычный",
  rare: "редкий",
  epic: "эпический",
  legendary: "легендарный",
};

/** Основной цвет редкости: рамки, свечение, полоса вероятности. */
export const RARITY_COLOR: Record<CaseRarity, string> = {
  common: "#8b93b8",
  uncommon: "#34d399",
  rare: "#38bdf8",
  epic: "#a78bfa",
  legendary: "#ffc65c",
};

/** Насколько сильно светится предмет: легендарка должна бить в глаза. */
export const RARITY_INTENSITY: Record<CaseRarity, number> = {
  common: 0.14,
  uncommon: 0.2,
  rare: 0.28,
  epic: 0.38,
  legendary: 0.55,
};

export function rarityTileStyle(rarity: CaseRarity, active = false) {
  const color = RARITY_COLOR[rarity];
  const intensity = RARITY_INTENSITY[rarity];

  return {
    borderColor: `color-mix(in oklab, ${color} ${active ? 90 : 45}%, transparent)`,
    background: `linear-gradient(160deg, color-mix(in oklab, ${color} ${
      intensity * 100
    }%, #12102e), #0b0a1f)`,
    boxShadow: active ? `0 0 28px color-mix(in oklab, ${color} 55%, transparent)` : undefined,
  };
}
